import React from 'react';
import { ColumnType } from 'antd/lib/table/interface';
import { t } from 'i18next';

import IbTable from '../../../../../../components/common/IbTable';
import { ContextElementModelOutput, Name } from '../../../../../../../gamma-api';

import { getFormPropertyType } from './utils';

export interface AppField {
  code: string;
  name?: string | Name;
  type?: string;
  isSelected: boolean;
  contextElementField: ContextElementModelOutput;
}

export interface ELMA365AppFieldsSelectorProps {
  fields: AppField[];
  loading?: boolean;
  onChange?: (selectedFieldsCodes: string[]) => void;
}

const ELMA365AppFieldsSelector: React.FC<ELMA365AppFieldsSelectorProps> = ({ fields, loading, onChange }) => {
  const columns: ColumnType<AppField>[] = [
    {
      title: t('Source settings: ELMA365: Field name'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
      width: '50%',
    },
    {
      title: t('Source settings: ELMA365: Field type'),
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => {
        const dataType = record.contextElementField.type.toLowerCase();
        const additionalDataType =
          (record.contextElementField.view?.data?.type as string | undefined) ||
          (record.contextElementField.view?.data?.currency as string | undefined);
        return getFormPropertyType(dataType, additionalDataType);
      },
      width: '50%',
    },
  ];

  const selectedRowKeys = fields.filter((f) => f.isSelected).map((f) => f.code);

  const handleSelectedRowKeysChange = (newKeys: React.Key[]) => {
    onChange?.(newKeys as string[]);
  };

  return (
    <IbTable
      columns={columns}
      dataSource={fields}
      loading={loading}
      rowKey="code"
      selectedRowKeys={selectedRowKeys}
      size="middle"
      onSelectedRowKeysChange={handleSelectedRowKeysChange}
    />
  );
};

export default ELMA365AppFieldsSelector;
